export default "__VITE_ASSET__eF8uG5EN__"